import React from 'react';
import { bool, func, string } from 'prop-types';
import { useAuthentication } from '@johnlewispartnership/wtr-website-authentication/dist/context';
import Button from '@johnlewispartnership/wtr-ingredients/dist/Button';
import config from 'config';

const logoutUrl = `${config.services.tokenClient.path}/v1/logout/oidc`;

// TODO: Merge this component with ../SignOut.js if possible
const SignOutButton = ({ loggedIn, onBlur, onClick, onFocus, width }) => {
  const { state: authState } = useAuthentication();

  return loggedIn && !authState.isSignedOnAsCustomer ? (
    <form action={logoutUrl} method="POST">
      <input type="hidden" name="_csrf" value={authState.tokenServiceCsrfToken} />
      <Button
        data-testid="sign-out-button"
        data-test="signOut"
        label="Sign out"
        onBlur={onBlur}
        onClick={() => {
          if (onClick) {
            onClick();
          }
        }}
        onFocus={onFocus}
        theme="secondary"
        type="submit"
        width={width}
      />
    </form>
  ) : null;
};

SignOutButton.propTypes = {
  loggedIn: bool.isRequired,
  onBlur: func,
  onClick: func,
  onFocus: func,
  width: string,
};

SignOutButton.defaultProps = {
  onBlur: null,
  onClick: null,
  onFocus: null,
  width: undefined,
};

SignOutButton.displayName = 'SignOutButton';

export default SignOutButton;
